/* ============================================================
   DOGVANTURE CONVERSION - v7 SAUBERER NEUAUFBAU
   ------------------------------------------------------------
   ZUSTAENDIGKEITEN:
   - Homepage: Hero-Button-Text, VID-Club-Text
   - Rich-Text-Block: Snack-Inspektoren-Titel-Korrektur
   - PDP: Buddy-Proof-Kasten mit dynamischer Inspektoren-Liste
   - PDP: Trial-Note und 100g-Vorauswahl
   - Sticky-Bar: killen falls von Legacy-Code injiziert

   NICHT hier: Karten-Layout / Karten-CSS (siehe card-uniformity.*)
   NICHT hier: PDP-Kauf-Button / Rating (siehe pdp-rollout.*)
   ============================================================ */
(() => {
  const norm = (s = '') => s.replace(/\s+/g, ' ').trim();

  // ------------------------------------------------------------
  // Snack-Inspektoren-Liste fuer PDP-Buddy-Proof-Kasten
  // Regel: Elvis + Linus + Emil + Bunny immer, Pauli NUR bei Ente.
  // ------------------------------------------------------------
  function inspectorList(title) {
    const t = title.toLowerCase();
    const names = ['Elvis', 'Linus', 'Emil'];
    if (t.includes('ente')) names.push('Pauli');
    names.push('Bunny');
    return names.slice(0, -1).join(', ') + ' & ' + names[names.length - 1];
  }

  function isSnackProduct(title) {
    return /würfel|kausnack|kauartikel|streifen|stick|lunge|pansen|haut|ohr|entenhals|entenhälse|lachshaut|fisch|pferd|hirsch|reh|ente|perlhuhn|gans|wildschwein|lamm|ziege/i.test(title);
  }

  // ------------------------------------------------------------
  // Homepage-Texte anpassen
  // ------------------------------------------------------------
  function enhanceHome() {
    const headings = [...document.querySelectorAll('h1,h2,h3')];

    const heroHeading = headings.find(h => norm(h.textContent).includes('WEIL JEDER HUND EIN ABENTEUER VERDIENT'));
    if (heroHeading) {
      const section = heroHeading.closest('.shopify-section');
      const heroButton = section?.querySelector('a.button');
      if (heroButton) {
        heroButton.textContent = 'Snack für meinen Buddy finden';
        heroButton.setAttribute('href', '#buddy-snack-finder');
      }
    }

    const vidHeading = headings.find(h => norm(h.textContent).includes('VID - VERY IMPORTANT DOG CLUB'));
    if (vidHeading) {
      vidHeading.textContent = 'THE VERY IMPORTANT DOG CLUB 👑';
      const section = vidHeading.closest('.shopify-section');
      const text = section?.querySelector('.rich-text__text');
      if (text) text.innerHTML = '<p class="dv-vid-note"><strong>Keine Models. Keine Stockfotos. Echte Buddys.</strong><br>Tag uns mit @dogvanture.official – und vielleicht landet dein Buddy hier oder bei uns im Feed.</p>';
      const button = section?.querySelector('a.button');
      if (button) button.textContent = 'Buddy zeigen →';
    }
  }

  // ------------------------------------------------------------
  // Snack-Inspektoren-Titel im Rich-Text-Block korrigieren
  // "FUENF BUDDY APPROVED" -> "EIN BUDDY APPROVED"
  // ------------------------------------------------------------
  function updateInspectorCopy() {
    [...document.querySelectorAll('h1,h2,h3')].forEach(h => {
      const text = norm(h.textContent).toLowerCase();
      if (!text.includes('vier snack inspektoren')) return;
      const section = h.closest('.shopify-section');
      h.textContent = 'FÜNF HUNDE. FÜNF MEINUNGEN. EIN BUDDY APPROVED.';
      const copy = section?.querySelector('.rich-text__text');
      if (copy) copy.innerHTML = '<p>Elvis, Linus, Emil, Pauli und Bunny sind unsere fünf Snack Inspektoren – fünf Tierschutzhunde mit ziemlich klarer Meinung zu guten Snacks.</p><p>Bunny verstärkt das Team als <strong>Chief Nimmersatt Officer</strong>. Gemeinsam entscheiden sie, was ein „Buddy Approved“ verdient.</p><p><strong>10 % unseres Gewinns gehen zurück an den Tierschutz.</strong> Echt. Nachhaltig. Ohne Marketing-Show.</p>';
    });
  }

  // ------------------------------------------------------------
  // Auf PDPs mit Probier- und Vorratsgroesse: 100g vorauswaehlen
  // ------------------------------------------------------------
  function selectTrialSize(info) {
    if (!info || info.dataset.dvTrialDefault === 'done') return false;
    const params = new URLSearchParams(window.location.search);
    if (params.has('variant')) {
      info.dataset.dvTrialDefault = 'done';
      return false;
    }
    const roots = [...info.querySelectorAll('variant-radios, variant-selects')];
    if (!roots.length) roots.push(info);
    for (const root of roots) {
      const radios = [...root.querySelectorAll('input[type="radio"]')];
      const trialRadio = radios.find(input => {
        const label = input.id ? [...info.querySelectorAll('label')].find(item => item.htmlFor === input.id) : null;
        const text = `${input.value || ''} ${label?.textContent || ''}`;
        return /(^|\D)100\s*g\b/i.test(text);
      });
      if (trialRadio) {
        info.dataset.dvTrialDefault = 'done';
        if (trialRadio.disabled || trialRadio.classList.contains('disabled')) return false;
        if (!trialRadio.checked) trialRadio.checked = true;
        trialRadio.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
      const selects = [...root.querySelectorAll('select')];
      for (const select of selects) {
        const option = [...select.options].find(opt => /(^|\D)100\s*g\b/i.test(`${opt.value || ''} ${opt.textContent || ''}`));
        if (!option) continue;
        info.dataset.dvTrialDefault = 'done';
        if (option.disabled) return false;
        if (select.value !== option.value) select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    return false;
  }

  function selectTrialSizeWhenReady(info) {
    if (!info || info.dataset.dvTrialDefault === 'done') return;
    const params = new URLSearchParams(window.location.search);
    if (params.has('variant')) {
      info.dataset.dvTrialDefault = 'done';
      return;
    }
    const run = () => requestAnimationFrame(() => setTimeout(() => selectTrialSize(info), 120));
    if (!window.customElements) {
      run();
      return;
    }
    const waits = [];
    if (!customElements.get('variant-selects')) waits.push(customElements.whenDefined('variant-selects'));
    if (!customElements.get('product-info')) waits.push(customElements.whenDefined('product-info'));
    if (waits.length) Promise.all(waits).then(run);
    else run();
  }

  function killStickyBar() {
    document.querySelectorAll('.dv-mobile-buy, .dv-atc-mobile').forEach(el => el.remove());
  }

  // ------------------------------------------------------------
  // Sicherheitsnetz: falsche Inspektoren-Liste im Buddy-Proof-Kasten
  // ueberschreiben (falls Cache alte Inspektoren-Liste liefert)
  // ------------------------------------------------------------
  function fixInspectorText() {
    const template = document.querySelector('main[data-template]')?.dataset.template || '';
    if (template !== 'product') return;
    const title = norm(document.querySelector('.product__title h1')?.textContent || '');
    if (!title) return;
    const expectedText = `🐾 Buddy approved von ${inspectorList(title)}`;
    document.querySelectorAll('.dv-product-proof__buddy').forEach(el => {
      if (norm(el.textContent) !== expectedText) el.textContent = expectedText;
    });
  }

  // ------------------------------------------------------------
  // PDP: Buddy-Proof-Kasten + Trial-Note einfuegen
  // ------------------------------------------------------------
  function enhanceProduct() {
    killStickyBar();
    const template = document.querySelector('main[data-template]')?.dataset.template || '';
    if (template !== 'product') return;
    const info = document.querySelector('.product__info-container');
    if (!info) return;
    const title = norm(document.querySelector('.product__title h1')?.textContent || document.title);
    if (!isSnackProduct(title)) return;

    info.querySelectorAll('.dv-product-proof').forEach(el => el.remove());
    const price = info.querySelector('[id^="price-"]');
    const proof = document.createElement('div');
    proof.className = 'dv-product-proof';
    const inspectors = inspectorList(title);
    proof.innerHTML = `<div class="dv-product-proof__facts"><span>✓ Monoprotein</span><span>✓ ohne Getreide</span><span>✓ ohne Zucker</span></div><p class="dv-product-proof__buddy">🐾 Buddy approved von ${inspectors}</p><p class="dv-product-proof__shipping">Versandkostenfrei ab 15 € · Lieferzeit ca. 2–4 Tage</p>`;
    if (price) price.insertAdjacentElement('afterend', proof);
    else info.prepend(proof);

    const pageText = norm(info.textContent);
    if (/100\s?g/i.test(pageText) && !info.querySelector('.dv-trial-note')) {
      const picker = info.querySelector('variant-selects, variant-radios, .product-form__input');
      if (picker) {
        const note = document.createElement('p');
        note.className = 'dv-trial-note';
        note.innerHTML = '<strong>Noch nie probiert?</strong> Klein starten, Buddy entscheiden lassen.';
        picker.insertAdjacentElement('beforebegin', note);
      }
    }

    selectTrialSizeWhenReady(info);
  }

  function init() {
    enhanceHome();
    updateInspectorCopy();
    enhanceProduct();
    setTimeout(killStickyBar, 500);
    setTimeout(killStickyBar, 2000);
    setTimeout(fixInspectorText, 300);
    setTimeout(fixInspectorText, 1500);
    const observer = new MutationObserver(() => {
      killStickyBar();
      fixInspectorText();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
